import { useMemo } from "react";

import useFilterStore from "@/stores/useFilterStore";

import { formatNumber } from "@/utils/numberFormat";
import { formatDate } from "@/utils/dateFormatter";
import { formatNameWithTooltip } from "@/utils/nameFormatter";
import { formatUser } from "@/utils/userFormatter";

import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

export function usePurchaseHistoryColumns(tableState) {
	const { filter } = useFilterStore();

	return useMemo(() => {
		const typeCurrency = filter?.type_currency || "USD";

		return [
			{
				Header: "#",
				accessor: "",
				disableSortBy: true,
				width: "2%",
				Cell: ({ row }) => {
					return <span>{(tableState.page - 1) * tableState.per_page + row.index + 1}</span>;
				},
			},
			{
				Header: "Fecha Ingreso",
				accessor: "created_date",
				width: "7%",
				Cell: ({ value }) => formatDate(value),
			},
			{
				Header: "Razón Social",
				accessor: "business_name",
				width: "10%",
				Cell: ({ value }) => {
					const { abbreviated, full } = formatNameWithTooltip(value);
					return <CustomTooltip text={abbreviated} description={full} />;
				},
			},
			{
				Header: "Distribuidor",
				accessor: "dealer_name",
				width: "9%",
				Cell: ({ value }) => {
					const { abbreviated, full } = formatNameWithTooltip(value);
					return <CustomTooltip text={abbreviated} description={full} />;
				},
			},
			{
				Header: "N° Factura",
				accessor: "sale_number",
				width: "7%",
				meta: { cellClassName: "tdCenter" },
			},
			{
				Header: "Fecha Factura",
				accessor: "billing_date",
				width: "7%",
				Cell: ({ value }) => formatDate(value),
			},
			{
				Header: "N° Guía",
				accessor: "delivery_number",
				width: "7%",
				meta: { cellClassName: "tdCenter" },
			},
			{
				Header: "Fecha Guía",
				accessor: "delivery_date",
				width: "7%",
				Cell: ({ value }) => formatDate(value),
			},
			{
				Header: "Campo",
				accessor: "field",
				width: "9%",
				Cell: ({ value }) => {
					const { abbreviated, full } = formatNameWithTooltip(value);
					return <CustomTooltip text={abbreviated} description={full} />;
				},
			},
			{
				Header: "Bodega",
				accessor: "warehouse",
				width: "9%",
				Cell: ({ value }) => {
					const { abbreviated, full } = formatNameWithTooltip(value);
					return <CustomTooltip text={abbreviated} description={full} />;
				},
			},
			{
				Header: "Cant.",
				accessor: "total_quantity",
				width: "5%",
				meta: { cellClassName: "tdRight" },
				Cell: ({ value }) => {
					return <span style={{ fontWeight: 500 }}>{formatNumber(value)}</span>;
				},
			},
			{
				Header: "Costo Total",
				accessor: "total_price_local",
				width: "8%",
				meta: { cellClassName: "tdRight" },
				Cell: ({ row }) => {
					const price = typeCurrency === "USD" ? row.original.total_price_usd : row.original.total_price_local;
					return <span style={{ fontWeight: 500 }}>${formatNumber(price)}</span>;
				},
			},
			{
				Header: "Usuario",
				accessor: "user_name",
				width: "7%",
				meta: { cellClassName: "tdCenter" },
				Cell: ({ value }) => {
					const { abbreviated, full } = formatUser(value);
					return <CustomTooltip text={abbreviated} description={full} />;
				},
			},
			{
				Header: "Tipo",
				accessor: "is_transfer",
				width: "5%",
				meta: { cellClassName: "tdCenter" },
				Cell: ({ value }) => {
					return value ? (
						<CustomBadge variant="warning" size="sm">
							Traspaso
						</CustomBadge>
					) : (
						<CustomBadge variant="primary" size="sm">
							Compra
						</CustomBadge>
					);
				},
			},
			{
				Header: "",
				accessor: "_expand",
				disableSortBy: true,
				width: "2%",
				Cell: () => null,
			},
		];
	}, [filter, tableState]);
}
